import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { getTranslatedText as translate } from "../Localization/Translation";

const useLaundry = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));

  const NotificationsStatusesAndText = [
    {
      status: "Laundry-Accept", //(ترسل عندما توافق المغسلة على الطلب)
      text: translate("Laundry-Accept", locale),
    },
    {
      status: "Laundry-Reject", //(ترسل عندما يرفض الطلب)
      text: translate("Laundry-Reject", locale),
    },
    {
      status: "Delivery-Accept", //حالة الطلب ← قيد الاحضار من العميل
      text: translate("Delivery-Accept", locale),
    },
    {
      status: "Laundry-Received-order", //(عندما يصل الطلب إلى المغسلة ولكن لم يتم بدء العمل عليه)
      // حالة الطلب ← قيد بدء التنفيذ
      text: translate("Laundry-Received-order", locale),
    },
    // {
    //   status: "Laundry-start-washing-notification", // حالة الطلب ← بدء التنفيذ
    //   text: translate("Laundry-start-washing-notification", locale),
    // },
    {
      status: "Laundry-finish-washing-ready-Delivering", // ( حالة الطلب ← جاهز للتسليم)
      text: translate("Laundry-finish-washing-ready-Delivering", locale),
    },
    {
      status: "Delivered", // ( بعدها بيظهر سؤال لتقييم الخدمة + كتابة ملاحظات ) حالة الطلب ← تم التسليم
      text: translate("Delivered-state", locale),
    },
    {
      status: "Free-Delivery",
      text: translate("Free-Delivery-notif", locale),
    },
    {
      status: "Discount",
      text: translate("Discount-notif", locale),
    },
  ];

  const notifications = [
    {
      id: "1",
      orderNumber: "120",
      done: false,
      status: NotificationsStatusesAndText[0].status,
      new: true,
      date: "2022-12-21 (10:00)",
      detailedOrder: [],
    },
    {
      id: "2",
      orderNumber: "118",
      done: false,
      status: NotificationsStatusesAndText[1].status,
      new: true,
      date: "2022-12-20 (09:00)",
      detailedOrder: [],
    },
    {
      id: "3",
      orderNumber: "119",
      done: false,
      status: NotificationsStatusesAndText[2].status,
      new: false,
      date: "2022-12-10 (12:00)",
      detailedOrder: [],
    },
    {
      id: "4",
      orderNumber: "110",
      done: false,
      status: NotificationsStatusesAndText[3].status,
      new: false,
      date: "2022-10-21 (08:00)",
      detailedOrder: [],
    },
    {
      id: "6",
      orderNumber: "89",
      done: true,
      status: NotificationsStatusesAndText[4].status,
      new: false,
      date: "2022-02-21 (12:00)",
      detailedOrder: [],
    },
    {
      id: "7",
      orderNumber: "88",
      done: true,
      status: NotificationsStatusesAndText[5].status,
      new: false,
      date: "2022-02-21 (12:00)",
      detailedOrder: [],
    },
    {
      id: "8",
      LaundryName: "الحياة",
      status: NotificationsStatusesAndText[6].status,
      new: false,
      date: "2022-02-21 (12:00)",
    },
    {
      id: "9",
      LaundryName: "النظافة",
      status: NotificationsStatusesAndText[7].status,
      new: false,
      date: "2022-02-21 (12:00)",
    },
  ];

  return {
    locale,
    notifications,
    NotificationsStatusesAndText,
  };
};

export default useLaundry;
